export const GET_ALL_SPECIAL_ROOMS = "GET_ALL_SPECIAL_ROOMS";
export const ADD_SPECIAL_ROOM = "ADD_SPECIAL_ROOM";
export const EDIT_SPECIAL_ROOM = "EDIT_SPECIAL_ROOM";
export const GET_SPECIAL_ROOM = "GET_SPECIAL_ROOM";
export const CLEAR_FOR_ADD_SPECIAL_ROOM = "CLEAR_FOR_ADD_SPECIAL_ROOM";
export const EDIT_SPECIAL_ROOM_PREDICTION = "EDIT_SPECIAL_ROOM_PREDICTION";